import { CircleIcon } from "@/components/ui/icon";
import { Radio, RadioIndicator, RadioIcon } from "@/components/ui/radio";
import { Text } from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import React from 'react';
import i18n from 'i18n-js';

// bg-ina-blue, bg-ina-green, bg-ina-yellow, bg-ina-orange, bg-ina-red
export default function RadioButton({ text, raw, onPress, variant, bg, value }) {
  return (
    <Button variant={variant} onPress={() => { onPress(value) }} className={` ${bg} border border-primary-900 w-[100%] rounded-md mx-2 my-1 `}>
      <Radio aria-label={i18n.t(text)} value={value} size="md" className="absolute left-3 top-2.5">
        <RadioIndicator sclassName="border-black">
          <RadioIcon as={CircleIcon} className={`${bg ? 'fill-white' : ''}`} />
        </RadioIndicator>
      </Radio>
      <Text className={` ${variant == 'solid' ? "text-secondary-50" : "text-primary-900"} font-[400] text-lg self-center `}>{raw ? text : i18n.t(text)}</Text>
    </Button>
  );
}